import {
  getRecoConsent,
  RecoConsentInterface,
  RichRelevanceConsent,
} from "./getRecoConsent";

window.ebConsentQueue = window.ebConsentQueue || [];

export default getRecoConsent(window.sessionStorage, window.ebConsentQueue);
export { RichRelevanceConsent, RecoConsentInterface };
